produto.component('produto.moduloComponent', {
    templateUrl: 'produto/modulo/modulo.html',
    controller: 'produto.moduloController',
    controllerAs: '$ctrl'
});

produto.controller('produto.moduloController', ['$rootScope', '$scope', 'coreLanguage', '$state', 'coreFb', '$filter', function($rootScope, $scope, $text, $state, $fb, $filter) {
    const $ctrl = this;
    $scope.$text = $text;   

    $ctrl.$onInit = () => {
        let idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        $rootScope.idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;

        let obj = {
            idProduto: $state.params.idProduto,
            idModulo: $state.params.idModulo,
            idUsuario : idUsuario,
            nextModulo: false,
            prevModulo:false,
            moduloPath: `cad_produtos/${$state.params.idProduto}/modulos/${$state.params.idModulo}`
        };

        $fb.db.list(`cad_produtos/${$state.params.idProduto}/modulos`).then(list=>{
            let modulo = $filter('filter')(list, {id:$state.params.idModulo}, true)[0];

            if(modulo.data.ordem > 1){
                obj.prevModulo = $filter('filter')(list, {data:{ordem: modulo.data.ordem - 1}}, true)[0].id;
            }

            if(modulo.data.ordem < list.length){
                obj.nextModulo = $filter('filter')(list, {data:{ordem: modulo.data.ordem + 1}}, true)[0].id;
            }

            $ctrl.configAulas = obj;
        });

    };
    
}]);